__turbopack_context__.v({
  "wrapper": "TextWithSubheading-module__1JRFRq__wrapper",
});
